import {Person, PersonType, Role, Scope} from "@betrue/shared/interfaces";
import {useReactiveVar} from "@apollo/client";
import {makeVarPersisted} from "@betrue/shared/utils";

const initialPerson: Person = {
  role: Role.USER,
  id: undefined,
  removed:false,
  scope: Scope.PARTNER,
  firstName: '',
  lastName: '',
  jobTitle: '',
  email: '',
  externalId: undefined,
  phone: '',
  profile: undefined,
  chatId:undefined,
  chatUsername:undefined,
  personType: PersonType.PHYSICAL
}

export const currentUserVar = makeVarPersisted<Person>(initialPerson, 'currentUserVar')


export const useCurrentUser = (): [Person, (p: Person) => void] => {
  return [useReactiveVar<Person>(currentUserVar), (user: Person) => currentUserVar(user)]
}
